/**
 * When the MpDebug cookie is set to true, we will show
 * logging for ecg-js-banners in the console
 */
const isDebugMode = () => typeof window !== 'undefined' && window.document?.cookie.includes('MpDebug=true');

export default isDebugMode;
